import React from 'react';
import styled from '@emotion/styled';

import { getItemVariantsString, getProductImageUrl } from '../../../helpers';
import { Link } from 'react-router-dom';

const Wrapper = styled('div')`
  .header-title {
    margin-bottom: 25px;
  }
  .product-image {
    width: inherit;
  }
`;

const ProductCard = (props) => {
  const { product } = props;
  return (
    <Wrapper className="row">
      <div className="col-12">
        <div className="card-box">
          <div className="row">
            <div className="col-12">
              <h4 className="header-title">Продукт</h4>
            </div>
          </div>
          <div className="row">
            <Link className="col-4 col-lg-12" to="..">
              <img className="product-image" src={getProductImageUrl(product, 250)} />
              <h4 className="header-title card-name">{product.shortName}</h4>
            </Link>
            <div className="col-8 col-lg-12">
              <p className="sub-header">{getItemVariantsString(product.variants.length)}</p>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ProductCard;
